import { useTranslation } from "react-i18next";
import type { MessageLocationPresentationDto } from "@multi-chat/shared";
import { locationCardSubtitle, locationCardTitle } from "../location-card.js";
import { openStreetMapEmbedUrl, openStreetMapUrl } from "../location-map-url.js";

export function MessageLocation({
  presentation,
}: {
  presentation: MessageLocationPresentationDto;
}): React.JSX.Element {
  const { t } = useTranslation();
  const title = locationCardTitle(presentation, t);
  const subtitle = locationCardSubtitle(presentation, title);
  const mapUrl = openStreetMapUrl(presentation.latitude, presentation.longitude);
  const embedUrl = openStreetMapEmbedUrl(presentation.latitude, presentation.longitude);

  const details = (
    <span className="block min-w-0 px-0.5 pt-1.5">
      <span className="block truncate text-[0.8125rem] font-medium text-ink">{title}</span>
      {subtitle ? (
        <span className="mt-0.5 block truncate text-[11px] text-ink-subtle">{subtitle}</span>
      ) : null}
    </span>
  );

  if (!mapUrl || !embedUrl) {
    return <div className="my-1 w-full max-w-full min-w-0">{details}</div>;
  }

  return (
    <a
      href={mapUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="my-1 block w-full max-w-full min-w-0 overflow-hidden rounded-lg border border-line/80 bg-surface/80 text-ink no-underline"
    >
      <span className="relative block aspect-[16/9] overflow-hidden bg-surface-muted">
        <iframe
          title={t("inbox.location.mapPreview")}
          src={embedUrl}
          loading="lazy"
          referrerPolicy="no-referrer"
          className="pointer-events-none absolute inset-0 h-full w-full border-0"
        />
      </span>
      <span className="block px-2.5 pb-2">{details}</span>
    </a>
  );
}
